import React from 'react';
import { PortableText } from '@portabletext/react';

import { StaticContentValue } from 'types/StaticContent';
import Typography from '../Typography';

export type StaticTextRendererProps = {
  text: StaticContentValue;
};

/*
 * Renders static text document as portable text on the page
 */
const StaticTextRenderer: React.FC<StaticTextRendererProps> = props => {
  if (typeof props.text === 'string') {
    return <>{props.text}</>;
  }

  return (
    <PortableText
      components={{
        block: {
          normal: ({ children }) => {
            return <Typography component="p">{children}</Typography>;
          },
        },
        marks: {
          em: ({ children }) => <em style={{ fontStyle: 'italic' }}>{children}</em>,
          // hr: () => <Divider />,
          strong: ({ children }) => <Typography variant="b">{children}</Typography>,
        },
      }}
      value={props.text}
    />
  );
};

export default StaticTextRenderer;
